'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = generateKey;

var _stringHash = require('string-hash');

var _stringHash2 = _interopRequireDefault(_stringHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var nonWordRe = /\W+/g;
var underscoreRe = /_+$/g;

function words(phrase) {
  return phrase.slice(0, 40).replace(nonWordRe, '_').replace(underscoreRe, '').toLowerCase();
}

function hash(phrase) {
  return (0, _stringHash2['default'])(phrase).toString(36).slice(0, 8);
}

function generateKey(prefix, phrase, context) {
  var phraseStrings = '' + String(phrase) + (context ? '_' + String(context) : '');
  return '' + String(prefix) + String(words(phraseStrings)) + '_' + String(hash(phraseStrings));
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-i18n/generateKey.js
// module id = 453
// module chunks = 168707334958949